import { ActionReducerMap } from '@ngrx/store';
import { EntitiesState } from './entities.state';
import { announcementEntitiesReducers } from '../announcement-entities/announcement-entities.reducers';
import { announcementDetailEntitiesReducers } from '../announcement-detail-entities/announcement-detail-entities.reducers';
import { userAnnouncementEntitiesReducers } from '../user-announcement-entities/user-announcement-entities.reducers';
import { announcementArchiveEntitiesReducers } from '../announcement-archive-entities/announcement-archive-entities.reducers';

/**
 * Kombinierter Reducer für alle Entity-Stores.
 */
export const entitiesReducers: ActionReducerMap<EntitiesState> = {
  announcementEntities: announcementEntitiesReducers,
  announcementDetailEntities: announcementDetailEntitiesReducers,
  userAnnouncementEntities: userAnnouncementEntitiesReducers,
  announcementArchiveEntities: announcementArchiveEntitiesReducers,
};
